/* Constantes gerais - carregadas do config_app.json */

import { getAppConfigs } from "../api";

export const API_URL_P = "https://bynameko.com/bes.api/api/";


// Valores padrão (caso o fetch falhe ou demore)
let config = {
  itensPorPagina: 3,
  language: "pt-BR",
  descontoMaximo: 0,
  chavePix: "",
  nomeFantasia: "",
  cidade: "",
};

// Função para carregar as configurações
export const loadConfig = async (token = null) => {
  try {
    let apiData = null;

    // 🔹 1. Tenta buscar da API se tiver token
    if (token) {
      try {
        apiData = await getAppConfigs(token);
      } catch (e) {
        console.warn("⚠️ Falha ao buscar config da API, usando fallback");
      }
    }

    // 🔹 2. Busca config local (fallback)
    const response = await fetch('/config_app.json', {
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });

    let localData = {};

    if (response.ok) {
      localData = await response.json();
    } else {
      console.warn("⚠️ config_app.json não encontrado");
    }

    // 🔥 3. Merge inteligente (prioridade API)
    config = {
      ...config,     // defaults
      ...localData,  // fallback
      ...apiData     // sobrescreve com API
    };

    return config;

  } catch (error) {
    console.error('❌ Falha geral ao carregar configurações', error);
    return config; // retorna o que tiver (defaults)
  }
};

// Exporta as configurações atuais (serão atualizadas após o loadConfig)
export const getConfig = () => config;

// Exporta valores individuais (mais prático de usar)
export const itensPorPagina = () => config.itensPorPagina;
export const language = () => config.language;
export const descontoMaximo = () => config.descontoMaximo;
export const chavePix = () => config.chavePix;
export const nomeFantasia = () => config.nomeFantasia;
export const cidade = () => config.cidade;
